<div class="h-screen w-screen flex flex-col bgcolor-gray-sys">
  <template-navbar></template-navbar>
  <div class="flex-1 overflow-auto pt-6 px-3 md:px-7">
    <router-outlet />
  </div>
  <div class="footer text-center pt-1.5 pb-0.5">
    <img
      class="scale-75"
      src="images/logo/logo-prolins-gray.png"
      alt="Logo Prolins"
    />
  </div>
</div>
